// import React from 'react';
// import { useQuery } from 'react-query';
// import { Box, Text, Image, Spinner, Alert, AlertIcon } from '@chakra-ui/react';
// import SplashService from '../../services/splashService';
// import Api from '../../api/ApiUrl'

// const SplashList = () => {
//   const { data, error, isLoading } = useQuery('splashscreens', SplashService.getAll);
// console.log(data)
//   if (isLoading) {
//     return <Spinner />;
//   }

//   if (error) {
//     return (
//       <Alert status="error">
//         <AlertIcon />
//         {error.message}
//       </Alert>
//     );
//   }

//   return (
//     <Box>
//       {data?.data?.data?.data?.map((splash) => (
//         <Box key={splash._id} borderWidth="1px" borderRadius="lg" overflow="hidden" mb={4}>
//           <Image src={`${Api}/${splash.coverphoto.path}`} alt={splash.coverphoto.name} />
//           <Box p="6">
//             <Text fontWeight="bold" fontSize="xl">{splash.name}</Text>
//             <Text mt="4">{splash.description}</Text>
//           </Box>
//         </Box>
//       ))}
//     </Box>
//   );
// };

// export default SplashList;








import React from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { Box, Text, Image, Spinner, Alert, AlertIcon, Button, useToast } from '@chakra-ui/react';
import Api from '../../api/ApiUrl'
import SplashService from '../../services/splashService';


const SplashList = () => {
  const queryClient = useQueryClient();
  const toast = useToast();
  
  const { data, error, isLoading } = useQuery('splashscreens', SplashService.getAll);

  const deleteMutation = useMutation((id) => SplashService.remove(id), {
    onSuccess: () => {
      queryClient.invalidateQueries('splashscreens');
      toast({
        title: 'Splash screen deleted.',
        description: 'The splash screen has been deleted successfully.',
        status: 'success',
        duration: 9000,
        isClosable: true,
      });
        window.location.reload();
    },
    onError: (error) => {
      toast({
        title: 'An error occurred.',
        description: error.response?.data?.message || 'Something went wrong.',
        status: 'error',
        duration: 9000,
        isClosable: true,
      });
    },
  });

  if (isLoading) {
    return <Spinner />;
  }

  if (error) {
    return (
      <Alert status="error">
        <AlertIcon />
        {error.message}
      </Alert>
    );
  }

  const handleDelete = (id) => {
    deleteMutation.mutate(id);
  };

  return (
    <Box>
      {data?.data?.data?.data?.map((splash) => (
        <Box key={splash._id} borderWidth="1px" borderRadius="lg" overflow="hidden" mb={4}>
          <Image src={`${Api}/${splash.coverphoto.path}`} alt={splash.coverphoto.name} />
          <Box p="6">
            <Text fontWeight="bold" fontSize="xl">{splash?.name}</Text>
            <Text mt="4">{splash?.description}</Text>
            <Button mt={4} colorScheme="red" onClick={() => handleDelete(splash._id)}>Delete</Button>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default SplashList;
